import { z } from "zod"

import { CompanyDefaultUnitOfMeasurement, CompanyPreferredMeasurementSystemEnum } from "@/graphql/codegen/graphql"
import type { CompanyType } from "@/types/companyType.ts"
import { CUSTOMER_COMPANY_TYPES, VENDOR_COMPANY_TYPES } from "@/types/companyType.ts"

export const CompanyModalSchema = z.object({
  name: z
    .string()
    .trim()
    .min(3, { message: "Company name must be at least 3 characters." })
    .max(50, { message: "Company name must not exceed 50 characters." })
    .regex(/^[a-zA-Z0-9&.,'\-()[\]! ]*$/, {
      message:
        "Company name can only contain letters, numbers, spaces, and these special characters: . , ' - ( ) [ ] & !",
    }),
  description: z.string().trim().max(30, { message: "Company Description must not exceed 30 characters" }).optional(),
  types: z
    .array(z.string())
    .min(1, { message: "This field is mandatory" })
    .superRefine((data, ctx) => {
      const hasCustomerType = data.some((type) => CUSTOMER_COMPANY_TYPES.includes(type as CompanyType))
      const hasVendorType = data.some((type) => VENDOR_COMPANY_TYPES.includes(type as CompanyType))

      if (hasCustomerType && hasVendorType) {
        ctx.addIssue({
          path: ["types"],
          message: "Company cannot be both Customer and Vendor at the same time",
          code: z.ZodIssueCode.custom,
        })
      }
    }),
  preferredMeasurementSystem: z.nativeEnum(CompanyPreferredMeasurementSystemEnum, {
    required_error: "Preferred measurement system is required",
  }),
  defaultUom: z.optional(z.nativeEnum(CompanyDefaultUnitOfMeasurement).or(z.literal(""))),
})

export type CreateCompanyFormData = z.infer<typeof CompanyModalSchema>
